module.exports = __webpack_public_path__ + "assets/img/audio.3cae69d5.png";